module.exports = __webpack_public_path__ + "static/media/windsurfing_768.be6062e8.jpg";